import React from 'react';
import styled from 'styled-components';
import { CascadeKrItem as CascadeKrData, CascadeKrListProps } from './cascadeKrTypes';
import { CascadeKrItem as CascadeKrRow } from './cascadeKrItem';

const StyledTable = styled('table')`
  width: -webkit-fill-available;
  && th {
    background-color: transparent;
    font-weight: 700;
  }
  & th,
  & td {
    color: #596373;
    font-feature-settings: 'liga' off;
    /* Body/Default */
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.021px;
    padding: 5px;
  }
`;

export const CascadeKrList = ({
  metrics = [],
  onDelete,
  onEdit,
  onValidationClick,
}: CascadeKrListProps) => {
  if (metrics.length === 0) {
    return null;
  }

  return (
    <StyledTable>
      <thead>
        <tr>
          <th style={{ width: '160px' }}>Owner</th>
          <th style={{ width: '-webkit-fill-available' }}>Name</th>
          <th style={{ width: '150px' }}>Target value</th>
        </tr>
      </thead>
      <tbody>
        {metrics.map((item: CascadeKrData) => (
          <CascadeKrRow
            key={item.id}
            item={item}
            onEdit={onEdit}
            onDelete={onDelete}
            onValidationClick={onValidationClick}
          />
        ))}
      </tbody>
    </StyledTable>
  );
};
